<template>
    <ResponsiveDialog
        v-model="internalValue"
        :max-width="420"
        :full-height="false"
        :header-title="$t('pokemon.common.endangeredInfoTitle')"
        header-class="skin-window-header--oak"
        card-class="skin-card"
    >
        <v-card-text class="transparent03 endangered-info-popup__body">
            {{ $t('pokemon.common.endangeredInfoText') }}
            <div class="endangered-info-popup__close-spacer" />
        </v-card-text>
    </ResponsiveDialog>
</template>

<script>
    import ResponsiveDialog from "@/components/utils/ResponsiveDialog";

    export default {
        name: 'EndangeredInfoPopup',
        components: {ResponsiveDialog},
        props: {
            value: {type: Boolean, default: false},
        },
        computed: {
            internalValue: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                },
            },
        },
    }
</script>

<style scoped>
.endangered-info-popup__body {
    font-size: 14px;
    line-height: 1.5;
}
/* prazdny pruh o vysce plovouciho krizku (ResponsiveDialog, mobil) - stejny vzor jako SkillDetailPopup.vue */
.endangered-info-popup__close-spacer {
    height: var(--responsive-dialog-close-clearance);
}
</style>
